export const translations = {
  en: {
    nav: {
      services: "Services",
      calculator: "Calculator",
      whyUs: "Why Us",
      contact: "Contact",
    },
    hero: {
      tagline: "NGV Conversion & Service Experts",
      headline: "Safe, Certified CNG Conversion & Maintenance in Tanzania",
      sub: "We install, maintain, and inspect CNG systems in Dar es Salaam. Trusted by drivers across Ubungo and beyond.",
      cta: "Call / WhatsApp",
      secondary: "Explore Services",
      location: "Dar es Salaam — Ubungo Maziwa Road",
    },
    services: {
      label: "What we do",
      title: "Complete CNG Services",
      subtitle: "Certified installation and maintenance for every NGV vehicle.",
      list: [
        { title: "CNG Installation", desc: "Professional NGV conversion with certified kits and pressure-rated cylinders." },
        { title: "Maintenance", desc: "Scheduled servicing to keep your CNG system efficient and reliable." },
        { title: "Inspection", desc: "Full system inspection aligned with Tanzanian safety standards." },
        { title: "Leak Testing", desc: "Precision leak detection at every joint, valve, and cylinder seal." },
        { title: "Pressure Test", desc: "Cylinder pressure testing to verify integrity and compliance." },
      ],
    },
    calculator: {
      label: "Savings Calculator",
      title: "How much will you save with CNG?",
      subtitle: "Enter your numbers. See monthly and yearly savings instantly.",
      petrolPrice: "Petrol price (TZS / litre)",
      cngPrice: "CNG price (TZS / kg)",
      distance: "Monthly distance (km)",
      dailyDistance: "Daily distance (km)",
      distanceMode: "Distance",
      daily: "Daily",
      monthly: "Monthly",
      petrolConsumption: "Petrol consumption (km/L)",
      cngConsumption: "CNG consumption (km/kg)",
      cngMode: "CNG consumption mode",
      autoMode: "Auto",
      manualMode: "Manual",
      autoNote: "Auto = Petrol consumption × 1.4",
      petrolCost: "Monthly cost on petrol",
      cngCost: "Monthly cost on CNG",
      dailySavings: "You save per day",
      monthlySavings: "You save per month",
      yearlySavings: "You save per year",
      note: "Defaults are typical for Tanzanian sedans. Adjust to match your vehicle.",
      reset: "Reset",
    },
    why: {
      label: "Why Choose Us",
      title: "Built on Safety, Proven by Drivers",
      items: [
        { title: "Certified Technicians", desc: "Trained and certified NGV installers with years of field experience." },
        { title: "Safe Service", desc: "Every installation is pressure-tested and leak-checked before handover." },
        { title: "Affordable", desc: "Transparent pricing and honest advice — no hidden fees." },
        { title: "Fast", desc: "Most installations completed within one working day." },
      ],
    },
    contact: {
      label: "Contact",
      title: "Visit our workshop",
      subtitle: "Reach out any time — we respond fast on WhatsApp.",
      phone: "Phone",
      location: "Location",
      instagram: "Instagram",
      directions: "Get Directions",
      address: "Ubungo Maziwa Road, Dar es Salaam, Tanzania",
    },
    footer: {
      tagline: "NGV Conversion & Service Experts",
      rights: "All rights reserved.",
      nav: "Navigation",
      reach: "Reach us",
    },
    common: {
      whatsapp: "WhatsApp",
      call: "Call",
    },
  },
  sw: {
    nav: {
      services: "Huduma",
      calculator: "Kikokotoo",
      whyUs: "Kwa Nini Sisi",
      contact: "Mawasiliano",
    },
    hero: {
      tagline: "Wataalamu wa Ubadilishaji na Huduma za NGV",
      headline: "Ubadilishaji na Huduma ya CNG Salama na Iliyothibitishwa Tanzania",
      sub: "Tunafunga, kutunza na kukagua mifumo ya CNG Dar es Salaam. Tunaaminiwa na madereva Ubungo na kwingineko.",
      cta: "Piga simu / WhatsApp",
      secondary: "Angalia Huduma",
      location: "Dar es Salaam — Barabara ya Ubungo Maziwa",
    },
    services: {
      label: "Tunafanya nini",
      title: "Huduma Kamili za CNG",
      subtitle: "Ufungaji na matengenezo yaliyothibitishwa kwa kila gari la NGV.",
      list: [
        { title: "Ufungaji wa CNG", desc: "Ubadilishaji wa NGV kitaalamu kwa vifaa vilivyothibitishwa." },
        { title: "Matengenezo", desc: "Huduma za kawaida ili mfumo wako wa CNG uendelee kuwa bora." },
        { title: "Ukaguzi", desc: "Ukaguzi kamili wa mfumo kulingana na viwango vya usalama Tanzania." },
        { title: "Upimaji wa Uvujaji", desc: "Utambuzi sahihi wa uvujaji kwenye kila kiungo na valvu." },
        { title: "Upimaji wa Shinikizo", desc: "Upimaji wa shinikizo la silinda kuthibitisha usalama." },
      ],
    },
    calculator: {
      label: "Kikokotoo cha Akiba",
      title: "Utaokoa kiasi gani na CNG?",
      subtitle: "Weka takwimu zako. Ona akiba ya mwezi na mwaka papo hapo.",
      petrolPrice: "Bei ya petroli (TZS / lita)",
      cngPrice: "Bei ya CNG (TZS / kg)",
      distance: "Umbali wa mwezi (km)",
      dailyDistance: "Umbali wa siku (km)",
      distanceMode: "Umbali",
      daily: "Siku",
      monthly: "Mwezi",
      petrolConsumption: "Matumizi ya petroli (km/L)",
      cngConsumption: "Matumizi ya CNG (km/kg)",
      cngMode: "Hali ya matumizi ya CNG",
      autoMode: "Otomatiki",
      manualMode: "Mwenyewe",
      autoNote: "Otomatiki = Matumizi ya petroli × 1.4",
      petrolCost: "Gharama ya mwezi kwa petroli",
      cngCost: "Gharama ya mwezi kwa CNG",
      dailySavings: "Unaokoa kwa siku",
      monthlySavings: "Unaokoa kwa mwezi",
      yearlySavings: "Unaokoa kwa mwaka",
      note: "Viwango vya msingi ni vya magari ya kawaida. Badilisha kulingana na gari lako.",
      reset: "Anza upya",
    },
    why: {
      label: "Kwa Nini Sisi",
      title: "Tunajengwa kwa Usalama, Tumethibitishwa na Madereva",
      items: [
        { title: "Mafundi Waliothibitishwa", desc: "Mafundi wa NGV waliofunzwa na wenye uzoefu wa miaka." },
        { title: "Huduma Salama", desc: "Kila ufungaji hupimwa shinikizo na uvujaji kabla ya kukabidhi." },
        { title: "Bei Rafiki", desc: "Bei wazi na ushauri wa kweli — hakuna gharama za siri." },
        { title: "Haraka", desc: "Ufungaji mwingi hukamilika ndani ya siku moja ya kazi." },
      ],
    },
    contact: {
      label: "Mawasiliano",
      title: "Tembelea karakana yetu",
      subtitle: "Wasiliana nasi wakati wowote — tunajibu haraka WhatsApp.",
      phone: "Simu",
      location: "Mahali",
      instagram: "Instagram",
      directions: "Pata Maelekezo",
      address: "Barabara ya Ubungo Maziwa, Dar es Salaam, Tanzania",
    },
    footer: {
      tagline: "Wataalamu wa Ubadilishaji na Huduma za NGV",
      rights: "Haki zote zimehifadhiwa.",
      nav: "Urambazaji",
      reach: "Wasiliana nasi",
    },
    common: {
      whatsapp: "WhatsApp",
      call: "Piga simu",
    },
  },
};

export const WHATSAPP_URL = "https://wa.me/255690051114";
export const TEL_URL = "tel:+255690051114";
export const INSTAGRAM_URL = "https://www.instagram.com/cng_autocare_tz?igsh=MWI1MjIyaHJwYTdheQ==";
export const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=Ubungo+Maziwa+Road+Dar+es+Salaam";
export const PHONE_DISPLAY = "+255 690 051 114";
